import {useCallback} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';

/**
 * Returns a stable callback that navigates to the Library scoped to a record
 * (/library?scope=typeId:recordId).
 *
 * Guard: if already on /library and the target record is already present in
 * the current scope param, the call is a no-op — clicking "Foo" when scope
 * already contains Foo should not collapse a multi-record scope.
 */
export function useNavigateToLibraryRecord() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (typeId: string, recordId: string | null) => {
      // Null record = a type-only ("Category") association — its click-through
      // is the Category scope (`typeId:*`), not a record page.
      const scopeRef = `${typeId}:${recordId ?? '*'}`;
      if (location.pathname === '/library') {
        const params = new URLSearchParams(location.search);
        const scopeParam = params.get('scope') ?? '';
        if (scopeParam.split(',').includes(scopeRef)) return;
      }

      navigate(`/library?scope=${scopeRef}`);
    },
    [navigate, location]
  );
}
